
import React, { useRef, useEffect, useCallback, useState } from "react";
import { ChatMessage as ChatMessageType } from "../types";
import ChatMessage from "./ChatMessage";
import TypingIndicator from "./TypingIndicator";
import MoodCheckIn from "./MoodCheckIn";

interface ChatMessageListProps {
  messages: ChatMessageType[];
  isTyping: boolean;
  isIdle?: boolean;
}

const ChatMessageList: React.FC<ChatMessageListProps> = ({ messages, isTyping, isIdle = false }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [moodResponded, setMoodResponded] = useState<Set<string>>(new Set());

  const scrollToBottom = useCallback(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping, scrollToBottom]);

  const handleMoodSelect = (msgId: string, mood: string) => {
    setMoodResponded((prev) => new Set(prev).add(msgId));
  };

  return (
    <div
      ref={scrollRef}
      className="flex-1 px-4 py-2 overflow-y-auto"
      style={{
        transform: isIdle ? 'translateY(12px)' : 'translateY(0)',
        visibility: isIdle ? 'hidden' as const : 'visible' as const,
        transition: 'transform 0.6s ease-in-out, visibility 0.6s ease-in-out',
      }}
    >
      <div className="space-y-4 pb-4">
        {messages.map((msg, i) => {
          const nextMsg = messages[i + 1];
          const showTime = msg.isUser || !nextMsg || nextMsg.isUser;
          return (
            <React.Fragment key={msg.id}>
              <ChatMessage message={msg} showTime={showTime} />
              {msg.moodCheck && !msg.isUser && !moodResponded.has(msg.id) && (
                <MoodCheckIn
                  conversationLength={messages.filter((m) => m.isUser).length}
                  onSelect={(mood) => handleMoodSelect(msg.id, mood)}
                />
              )}
            </React.Fragment>
          );
        })}
        {isTyping && <TypingIndicator />}
      </div>
    </div>
  );
};

export default ChatMessageList;
